import { useField } from 'formik'
import { motion } from 'framer-motion'
import React from 'react'
import ErrorIcon from '../icons/ErrorIcon'

const telLabels = ['telefonnummer', 'téléphone', 'telefono']

const sanitizeInput = (value, isPhoneNumber) => {
  if (isPhoneNumber) {
    return value.replace(/[^0-9+\s]/g, '')
  }
  return value
}

const FormTextInput = ({
  handle,
  name,
  required,
  containerAttributes,
  isFullWidth = false,
}) => {
  const [{ value }, { error, touched }, { setValue }] = useField(handle)
  const notEmpty = `${value}`.length > 0

  const fullWidth =
    isFullWidth ||
    !!containerAttributes?.find(
      att => att.label === 'fullWidth' && att.value === 'true',
    )
  const isPhoneNumber = telLabels.some(label =>
    name.toLowerCase().includes(label),
  )

  return (
    <div className="flex mb-8">
      <div className={fullWidth ? 'w-full' : 'w-full lg:w-1/2 lg:pr-4'}>
        <div className="relative flex">
          <motion.label
            className={`absolute z-0 inline-flex px-1 pointer-events-none left-2.5 top-[11px] ${
              !notEmpty && 'w-full'
            }`}
            style={{
              backgroundColor: notEmpty ? '#F5F5F5' : 'transparent',
              fontSize: notEmpty ? '10px' : '16px',
            }}
            animate={{
              y: notEmpty ? -18 : 0,
            }}
            transition={{ type: 'ease' }}
          >
            <div
              className="overflow-hidden whitespace-nowrap overflow-ellipsis"
              style={{
                width: notEmpty
                  ? 'auto'
                  : error && touched
                  ? 'calc(100% - 40px)'
                  : 'calc(100% - 16px)',
              }}
            >
              {name}
              {required ? '*' : ''}
            </div>
          </motion.label>

          <input
            type={isPhoneNumber ? 'tel' : 'text'}
            id={handle}
            name={handle}
            className={`w-full px-3 bg-transparent border text-base rounded ${
              error && touched ? 'border-red' : 'border-gray-5'
            } h-11 focus:border-black focus:outline-none focus:ring-1 focus:ring-black`}
            value={value}
            onChange={e =>
              setValue(sanitizeInput(e.target.value, isPhoneNumber))
            }
          />
          {error && touched && (
            <ErrorIcon className="absolute z-20 top-1.5  right-2" />
          )}
        </div>
      </div>
    </div>
  )
}

export default FormTextInput
